const Products = (function () {
    'use strict'

    let products;
    let productsList;
    let productDetails;
    let toolbar;
    let pid;

    const init = () => {
        products = document.querySelector('[data-hook=products]');
        productsList = document.querySelector('[data-hook=products-list]');
        productDetails = document.querySelector('[data-hook=product-details]');
        toolbar = document.querySelector('[data-hook=toolbar]');
    }

    const close = function () {
        $(productDetails).removeAttr('data-is-visible');
        $(productsList).removeAttr('data-is-hidden');
        $(document.body).animate({
            'scrollTop': $(pid).offset().top - 100,
        }, 0);
    }

    const open = function (el) {
        $(productDetails).attr('data-is-visible', '');
        $(productsList).attr('data-is-hidden', '');
        document.querySelector('#products').scrollIntoView({});
        Slider.refresh();
        pid = el;
        $(document.body).animate({
            'scrollTop': $('#products').offset().top
        }, 0);

        if(products != null) {
            products.setAttribute('data-overlay-mode', '');
            location.hash = '#products';
            location.hash.replace('#', '');
        }
        if(toolbar != null) {
            toolbar.setAttribute('data-overlay-mode', '');
        }
    }

    return {
        init: init,
        close: close,
        open: open,
    }
})();
